import './slots.scss'
